import type { SxProps } from '@mui/joy/styles/types';

export const mergeSx = (...sx: (SxProps | null | undefined)[]): SxProps => [
  ...sx.flatMap((sx) => (Array.isArray(sx) ? sx : [sx])).filter((sx) => !!sx),
];
